import BookIcon from '@material-ui/icons/Book'
import UserSellShow from './UserSellOrderShow'
import UserSellList from './UserSellOrderList'

export default {
  list: UserSellList,
  show: UserSellShow,
  icon: BookIcon,
}
